import React, { Component } from 'react'
import RatingsControl from './RatingsControl'

import '../scss/RatingsControlContainer.scss'

class RatingsControlContainer extends Component
{
    constructor (props){
        super(props)
        this.state = {
            ratingOptions: props.ratingOptions
        }

    }

    render(){

        if ('' === this.state.ratingOptions.type)
            return null;

        return (
            <div className="RatingsControlContainer" data-display={this.props.display}>
                <RatingsControl {... this.props} type={this.state.ratingOptions.type} score={this.state.ratingOptions.currentScore} rated={this.state.ratingOptions.rated} handleRatingClick={this.props.handleRatingClick}/>
            </div>
        )
    }
}

export default RatingsControlContainer